export function externalLinkHelper(env, to, target, userDomainRegion) {
    if (to &&
        (to.startsWith('http:') ||
            to.startsWith('https:') ||
            to.startsWith('mailto:') ||
            to.startsWith('tel:') ||
            target === '_blank')) {
        const hokifyHost = env === 'production'
            ? `https://hokify.${userDomainRegion}`
            : `https://test.hokify.${userDomainRegion}`;
        return `${target === '_blank' &&
            !to.startsWith('http:') &&
            !to.startsWith('https:') &&
            !to.startsWith('mailto:') &&
            !to.startsWith('tel:')
            ? hokifyHost
            : ''}${to}`;
    }
    return undefined;
}
//# sourceMappingURL=externalLink.js.map